module.exports = __webpack_public_path__ + "static/media/helpUseAppGif.fdec29da.gif";